/* eslint-disable */
import testimonial_image from '../assets/svg/testimonials/1517071038234.jpeg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Ameer Hamza',
        title: 'Senior AI Engineer @ Fynder AI',
        text: "Sameed from the beginning has been a proficient go getter and an amazing resource to have. His no frills approach to difficult problems makes him a standout and an amazing companion. Above all is his total determination to go above and beyond the scope in ways that make his work stand out even more.",
        image: testimonial_image
    }
]

